import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLogout } from "../../hooks/useLogout";
import {
  useGetClinicDetails,
  useGetProfileStatus,
  useGetProviderDetails,
} from "../../hooks/useProvider";
import assets from "../../utils/Assets";
import OTPVerificationContainer from "../otpVerification/OTPVerificationContainer";
import MainMenu from "./MainMenu";
import MainMenuVideo from "./MainMenuVideo";
import ProviderLoginMenuItems from "./ProviderLoginMenuItems";
import SidebarMenu from "./SidebarMenu";
import withClickOutside from "./withClickOutside";

const ProvidersMenu = React.forwardRef(({ setOpen, open }, ref) => {
  //const { refetch, data: logoutData } = useLogout();
  const { mutateAsync: logoutMutate } = useLogout();
  const useAuth = () => {
    const user = localStorage.getItem("userID");
    return Boolean(user);
  };
  const user = useAuth();
  const location = useLocation();
  const navigation = useNavigate();

  const { data: providerData } = useGetProviderDetails(
    localStorage.getItem("userID") ? localStorage.getItem("userID") : "",
  );
  const { data: profileCompletionData } = useGetProfileStatus(
    localStorage.getItem("userID"),
  );
  const { data: clinicData } = useGetClinicDetails(
    providerData?.provider?.providerId,
  );

  useEffect(() => {
    if (clinicData?.status === "SUCCESS" && clinicData?.clinicProvider) {
      localStorage?.setItem(
        "clinicId",
        clinicData?.clinicProvider[0]?.clinicId,
      );
    }
  }, [clinicData]);
  const logout = async () => {
    try {
      const response = await logoutMutate();

      if (response?.status === "SUCCESS") {
        localStorage.removeItem("auth");
      }

      localStorage.removeItem("userID");
      localStorage.removeItem("providerId");
      localStorage.removeItem("clinicId");
      localStorage.removeItem("expires_in");
      localStorage.removeItem("isSCAdmin");
      localStorage.removeItem("refresh_token");

      if (providerData?.provider?.isWebAiSignUp === true) {
        navigation("/login?meragoai=true");
      } else {
        navigation("/login");
      }

      setOpen(false);
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  useEffect(() => {
    if (providerData?.status === "SUCCESS") {
      localStorage.setItem("providerId", providerData?.provider?.providerId);
      localStorage.setItem("providerUn", providerData?.provider?.userName);
      localStorage.setItem(
        "isSCAdmin",
        providerData?.provider?.secondOpinionAdmin,
      );
    }
  }, [providerData]);

  return (
    <>
      {user && (
        <div
          className={
            providerData?.provider?.providerVerificationStatus ===
            "VERIFIED_AND_APPROVED"
              ? "navbar"
              : "navbarvideo"
          }
          ref={ref}
        >
          <div className="navbar__left">
            <div className="navbar__logo">
              <img
                src="https://static.meragoapp.com/images/menuLogo.png"
                alt="logo"
                width="55px"
                height="55px"
              />
            </div>

            <div className="navbar__items">
              {/* {providerData?.provider?.providerVerificationStatus ===
                "VERIFIED_AND_APPROVED" && (
                <MainMenu
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                />
              )} */}

              {providerData?.provider?.providerVerificationStatus ===
              "VERIFIED_AND_APPROVED" ? (
                <MainMenu
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                />
              ) : (
                <MainMenuVideo
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                  profileCompletionData={profileCompletionData}
                />
              )}
            </div>
          </div>
          <>
            {providerData?.provider?.providerVerificationStatus ===
            "VERIFIED_AND_APPROVED" ? (
              <></>
            ) : (
              <></>
              // <div
              //   style={{
              //     display: "flex",
              //     flexDirection: "column", // 👈 makes children vertical
              //     alignItems: "center", // 👈 center horizontally
              //     height: "70px",
              //     justifyContent: "center",
              //     position: "absolute",
              //     left: "50%",
              //     transform: "translateX(-50%)",
              //     // 👈 center vertically in 70px height
              //   }}
              // >
              //   <div
              //     style={{
              //       display: "flex",
              //       justifyContent: "center",
              //     }}
              //   >

              //     <img
              //       src={
              //         providerData?.provider?.isScribeEnabled === true
              //           ? "https://static.meragoapp.com/meragotest/merago_ai_scribe2.png"
              //           : "https://static.meragoapp.com/meragotest/merago-ai-hero.png"
              //       }
              //       alt="Welcome"
              //       className="register__text"

              //       style={{
              //         width: providerData?.provider?.isScribeEnabled
              //           ? "320px"
              //           : "180px",
              //         marginTop: "10px",
              //         height: "48px",
              //       }}
              //     />
              //   </div>

              //   <p
              //     className="register__text"
              //     style={{ color: "#557876", fontSize: "16px", margin: 0 }}
              //   >
              //     Your intelligent virtual assistant​
              //   </p>
              // </div>
            )}
          </>

          <div className="sideBar__main" onClick={() => setOpen(!open)}>
            <p>
              {providerData?.provider?.person.salutation?.salutation}{" "}
              {providerData?.provider?.person?.name}
            </p>
            <img
              src={assets.downArrow}
              alt="merago"
              width="15px"
              height="15px"
            />
          </div>
          {open ? (
            <>
              <div
                className={`sidebar__conatiner ${
                  providerData?.provider?.providerVerificationStatus ===
                  "VERIFIED_AND_APPROVED"
                    ? ""
                    : "not-approved"
                }`}
              >
                <SidebarMenu
                  setOpen={setOpen}
                  open={open}
                  providerData={providerData?.provider}
                  clinicData={clinicData}
                  profileCompletionData={profileCompletionData}
                />

                {location.pathname !== "/login" && (
                  <button onClick={logout}>Logout</button>
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      )}
      <ProviderLoginMenuItems />
      {providerData?.provider?.providerVerificationStatus ===
        "VERIFIED_AND_APPROVED" &&
        profileCompletionData?.serviceInfo === true &&
        !providerData?.provider?.mobileConfirmed && (
          <OTPVerificationContainer />
        )}
    </>
  );
});

export default withClickOutside(ProvidersMenu);
